import { createRoutine } from 'redux-saga-routines';

export const fetchEventConfigInterval = createRoutine(
  'FETCH_EVENT_CONFIG_INTERVAL'
);

export const saveEventConfigInterval = createRoutine(
  'SAVE_EVENT_CONFIG_INTERVAL'
);

export const changeEventConfigInterval = createRoutine(
  'CHANGE_EVENT_CONFIG_INTERVAL'
);

export const cancelEventConfigInterval = createRoutine(
  'CANCEL_EVENT_CONFIG_INTERVAL'
);
